import Layout from '@/components/Layout';

export default function TestComponents(): JSX.Element {
  return (
    <Layout pageName="Test">
      <div>Test components here</div>
    </Layout>
  );
}
